import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { EmptyState } from "../../components/ui/empty-state";
import { getRamos, deleteRamo } from "../../services/adminRamosService";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Pencil, PlusCircle, Trash2 } from "lucide-react";

export default function RamosList() {
  const [ramos, setRamos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRamos();
  }, []);

  const loadRamos = async () => {
    try {
      setLoading(true);
      const data = await getRamos();
      setRamos(data);
    } catch (error) {
      console.error("Error loading ramos:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (ramo) => {
    try {
      await deleteRamo(ramo.id);
      setRamos(ramos.filter(r => r.id !== ramo.id));
    } catch (error) {
      console.error("Error deleting ramo:", error);
    }
  };

  return (
    <div className="@container/main p-6 space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Admin: Ramos</h1>
          <p className="text-gray-600">Configuración de ramos</p>
        </div>
        <Link to="/admin/ramos/new">
          <Button className="flex items-center gap-2 bg-[#007D6E] hover:bg-[#006358] text-white">
            <PlusCircle className="h-5 w-5" />
            Nuevo Ramo
          </Button>
        </Link>
      </div>

      {loading ? (
        <div className="flex justify-center py-10">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#007D6E]"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6 px-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
          {ramos.length === 0 ? (
            <div className="col-span-full">
              <EmptyState
                icon={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>}
                title="Sin ramos"
                description="No hay ramos configurados aún en el sistema."
              />
            </div>
          ) : (
            ramos.map(ramo => (
              <Card key={ramo.id} className="rounded-xl border border-gray-200 bg-white/60 shadow-sm transition-all">
                <CardHeader>
                  <CardDescription>{ramo.codigo || 'Sin código'}</CardDescription>
                  <CardTitle className="text-2xl font-semibold">{ramo.nombre}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  {ramo.descripcion && <p className="text-sm text-muted-foreground">{ramo.descripcion}</p>}
                </CardContent>
                <CardFooter className="flex justify-end gap-2">
                  <Link to={`/admin/ramos/${ramo.id}`}>
                    <Button variant="outline" size="sm">
                      <Pencil className="h-4 w-4" />
                    </Button>
                  </Link>
                  <Button
                    variant="outline"
                    size="sm"
                    className="text-[var(--yool-error)] hover:text-red-700 hover:bg-red-50"
                    onClick={() => handleDelete(ramo)}
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </CardFooter>
              </Card>
            ))
          )}
        </div>
      )}
    </div>
  );
}